import {
  call, all, takeLatest, put,
} from 'redux-saga/effects';
import { getWeatherDataFailureAction, getWeatherDataSuccessAction } from '../actions/weatherActions';
import { WEATHER_DATA_REQUEST } from '../actions/types/weatherActionTypes';
import { api } from '../api';

function* doWeatherWorker(action) {
  try {
    const res = yield call(api.currentWeather, action.payload);
    yield put(getWeatherDataSuccessAction(res.data));
  } catch (error) {
    yield put(getWeatherDataFailureAction(error));
  }
}

export function* doWeatherWatcher() {
  yield takeLatest(WEATHER_DATA_REQUEST, doWeatherWorker);
}

function* weatherSaga() {
  yield all([
    doWeatherWatcher(),
  ]);
}

export default weatherSaga;
